var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
let BrandJobTitlesModel = class BrandJobTitlesModel {
    constructor() {
        this.id = -1;
        this.color = '';
        this.name = '';
        this.status = '';
        this.code = '';
        this.is_payable = false;
    }
};
__decorate([
    JsonProperty("id", Number)
], BrandJobTitlesModel.prototype, "id", void 0);
__decorate([
    JsonProperty("color", String, true)
], BrandJobTitlesModel.prototype, "color", void 0);
__decorate([
    JsonProperty("name", String)
], BrandJobTitlesModel.prototype, "name", void 0);
__decorate([
    JsonProperty("status", String)
], BrandJobTitlesModel.prototype, "status", void 0);
__decorate([
    JsonProperty("code", String)
], BrandJobTitlesModel.prototype, "code", void 0);
__decorate([
    JsonProperty("is_payable", Boolean, true)
], BrandJobTitlesModel.prototype, "is_payable", void 0);
BrandJobTitlesModel = __decorate([
    JsonObject("BrandJobTitlesModel")
], BrandJobTitlesModel);
export { BrandJobTitlesModel };
//# sourceMappingURL=brand-job-titles.model.js.map